module.exports = __webpack_public_path__ + "d8213ebaaf248522cda97c30702d018e.png";